import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import { Collapse, List, ListItemButton, Typography } from '@mui/material';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';

const NavGroup = ({ item, active, open, onToggle, first }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const customization = useSelector((state) => state.customization);

  const items = item.children?.map((menu) => {
    switch (menu.type) {
      case 'collapse':
        return <NavCollapse key={menu.id} menu={menu} level={1} />;
      case 'item':
        return <NavItem key={menu.id} item={menu} level={1} />;
      default:
        return (
          <Typography key={menu.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return (
    <>
      <ListItemButton
        onClick={onToggle}
        aria-expanded={open}
        sx={{
          mt: first ? 0 : 0.25,
          minHeight: 26,
          py: 0,
          px: 1,
          borderRadius: `${customization.borderRadius}px`,
          color: active ? theme.palette.primary.main : theme.palette.text.secondary,
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        }}
      >
        <Typography
          variant="caption"
          sx={{
            flex: 1,
            fontSize: '0.6875rem',
            fontWeight: active ? 700 : 600,
            letterSpacing: '0.06em',
            lineHeight: 1.4,
            textTransform: 'uppercase',
            color: 'inherit'
          }}
        >
          {t(`menu.${item.id}`)}
        </Typography>
        {open ? <IconChevronUp size="0.9rem" /> : <IconChevronDown size="0.9rem" />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List disablePadding>{items}</List>
      </Collapse>
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object,
  active: PropTypes.bool,
  open: PropTypes.bool,
  onToggle: PropTypes.func,
  first: PropTypes.bool
};

export default NavGroup;
